import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { SortMenu } from "../dropdowns/menus";

class SortBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initState();
    }

    initState = () => {
        let defaultSort = this.props.defaultSort || null;
        let state = {
            sortBy: Array.isArray(defaultSort) ? defaultSort : (defaultSort ? [defaultSort] : [])
        };

        let SORT_OPTIONS = [];

        if (this.props.includeTypeSort) {
            SORT_OPTIONS.push({ value: "docType|DESC", label: "Frames First" });
            SORT_OPTIONS.push({ value: "docType|ASC", label: "Fabrics First" });
        }

        SORT_OPTIONS.push({ value: "name|ASC", label: "Name. A-Z" });
        SORT_OPTIONS.push({ value: "name|DESC", label: "Name. Z-A" });
        SORT_OPTIONS.push({ value: "sku|ASC", label: "Style Number. A-Z" });
        SORT_OPTIONS.push({ value: "sku|DESC", label: "Style Number. Z-A" });

        if (!this.props.excludePriceSort) {
            SORT_OPTIONS.push({ value: "priceValue|ASC", label: "Price. Low to High" });
            SORT_OPTIONS.push({ value: "priceValue|DESC", label: "Price. High to Low" });
        }

        state.sortOptions = SORT_OPTIONS;
        return state;
    }

    isTypeSort = (value) => {
        return value && value.startsWith("docType|");
    }

    toggleValue = (group, value) => {
        this.setState(prev => {
            let current = prev.sortBy.slice();
            let isType = this.isTypeSort(value);
            let idx = current.indexOf(value);

            if (idx > -1) {
                // Deselecting
                current.splice(idx, 1);
            } else if (isType) {
                // Selecting a type sort — replace any existing type sort, keep one non-type
                current = current.filter(v => !this.isTypeSort(v));
                current.unshift(value);
                // Cap at 2
                if (current.length > 2) current = current.slice(0, 2);
            } else {
                // Selecting a non-type sort — replace any existing non-type sort
                current = current.filter(v => this.isTypeSort(v));
                current.push(value);
                // Cap at 2
                if (current.length > 2) current = current.slice(0, 2);
            }

            return { sortBy: current };
        }, () => {
            if (typeof this.props.onSortChange === "function") {
                this.props.onSortChange(this.state.sortBy);
            }
        });
    };

    render() {
        const { sortBy, sortOptions } = this.state;
        return (
            <div>
                <div className="sort-bar">
                    <FilterDropdown label="Sort&nbsp;By">
                        {({ close }) => (
                            <SortMenu
                                options={sortOptions}
                                selectedValues={sortBy}
                                onToggle={(value) => this.toggleValue("sortBy", value)}
                            />
                        )}
                    </FilterDropdown>
                </div>
            </div>
        );
    }
}

export default SortBar;
